import React from "react";
import DateTimePicker from "../../app/DateTimePicker";
import { Form, Input } from "semantic-ui-react";
import FormLabel from "../../common/FormLabel";

interface CaseFormInputDateTimeProps {
  label: string;
  value: string;
  onChange(value: string): void;
  labelWidth?: string;
  placeholder?: string;
}

const CaseFormInputDateTime = (props: CaseFormInputDateTimeProps) => {
  const { label, labelWidth, ...restProps } = props;
  const width = labelWidth || "100px";
  return (
    <Form.Group inline>
      <Form.Field required>
        <FormLabel width={width}>{label}</FormLabel>
        <Input>
          <DateTimePicker type="datetime" {...restProps} />
        </Input>
      </Form.Field>
    </Form.Group>
  );
};

export default React.memo(CaseFormInputDateTime);
